module.exports = __webpack_public_path__ + "img/Weapon_22.37755c14.png";